<mat-slide-toggle
  #viewswitch
  (change)="changeTheme()"
  [checked]="checked"
  [disabled]="disabled"
  >
</mat-slide-toggle>